const { makeRequest } = require('services/api/ufeApi');
const catalogUtils = require('utils/Catalog');

// https://jira.sephora.com/browse/INFL-1011

function getGroupedBrandsList() {
    let url = '/api/catalog/groupedBrandsList';

    if (catalogUtils.isBXSServiceEnabled()) {
        url = '/api/v2/catalog/groupedBrandsList';
    }

    return makeRequest(url).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = { getGroupedBrandsList };
